<template>
  <div id="history">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/history.jpg'); height:50vh;">
      <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                  <h1 class="title" id="hide_edit" @click="edit_milestone">發展里程碑</h1>
                  <h3 class="title description">Milestone</h3>
                </div>
            </div>
          </div>
      </div>
    </div>
    <div class="main main-raised">
        <div class="container">
          <div class="section">
            <div class="row">
              <div class="col-md-12">
                <ul class="cbp_tmtimeline">
                  <template v-if="data.length > 0">
                    <template v-for="(item, index) in data">
                      <li :key="index">
                          <div style="cursor: pointer;" data-toggle="collapse" aria-expanded="true"  :data-target="'.collapseOne' + index">
                              <time class="cbp_tmtime" ><span class="hidden">{{ item.title_cht }}</span>
                                  <span>{{ item.title_eng }}</span>
                              </time>
                              <div class="cbp_tmicon">
                                  <!-- <img class="img" :src="item.title_pic | imgUrl" /> -->
                                  <img class="img" :src="item.title_pic" />
                              </div>
                          </div>
                          <template v-for="sub_item in item.list">
                              <template  v-if="index == 0">
                                  <div class="cbp_tmlabel collapse show" :class="'collapseOne' + index" :key="sub_item.id">
                                      <span class="text-primary font-weight-bold">{{sub_item.years}}</span>
                                      <p>
                                          {{ sub_item.description.cht }}<br />
                                          {{ sub_item.description.eng }}
                                      </p>
                                  </div>
                              </template>
                              <template v-else>
                                  <div class="cbp_tmlabel collapse" :class="'collapseOne' + index" :key="sub_item.id">
                                      <span class="text-primary font-weight-bold">{{sub_item.years}}</span>
                                      <p>
                                          {{ sub_item.description.cht }}<br />
                                          {{ sub_item.description.eng }}
                                      </p>
                                  </div>
                              </template>
                          </template>
                      </li>
                    </template>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "history",
  props: [],
  data() {
    return {
      data: []
    };
  },
  methods: {
    gethistoryInfo: function() {
      var vm = this;
      // console.log("gethistoryInfo");
      var data = [];
      axios
        .get(`/api/gethistoryInfo`)
        .then(res => {
          // console.log(res.data.data);
          data = res.data.data;

          for (var i = 0; i < data.length; i++) {
            var title_queue = data[i].title_queue;
            var id = data[i].id;

            if (i == 0) {
              vm.data.push({
                title_cht: data[i].title_cht,
                title_eng: data[i].title_eng,
                title_pic: data[i].img,
                list: [
                  {
                    id: data[i].id,
                    years: data[i].years,
                    description: {
                      cht: data[i].description_cht,
                      eng: data[i].description_eng
                    }
                  }
                ]
              });
            } else {
              var data_len = vm.data.length;

              if (title_queue == data[i - 1].title_queue) {
                vm.data[data_len - 1].list.push({
                  id: data[i].id,
                  years: data[i].years,
                  description: {
                    cht: data[i].description_cht,
                    eng: data[i].description_eng
                  }
                });
              } else {
                vm.data.push({
                  title_cht: data[i].title_cht,
                  title_eng: data[i].title_eng,
                  title_pic: data[i].img,
                  list: [
                    {
                      id: data[i].id,
                      years: data[i].years,
                      description: {
                        cht: data[i].description_cht,
                        eng: data[i].description_eng
                      }
                    }
                  ]
                });
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    edit_milestone: function() {
      var vm = this;
      document
        .querySelector("#hide_edit")
        .addEventListener("click", function(evt) {
          // console.log(evt.detail)

          if (evt.detail === 3) {
            vm.$router.push("/about/edit_history").catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
        });
    },
  },
  filters: {
    imgUrl: function(value) {
      if (value != null) {
        value = "/static/img/icons/" + value + ".png";
      } else {
        value = "/static/img/placeholder.jpg";
      }

      return value;
    }
  },
  computed: {},
  created() {
    this.gethistoryInfo();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

.cbp_tmtimeline {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
}

.cbp_tmtimeline:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #eee;
  left: 20%;
  margin-left: -6px;
}

.cbp_tmtimeline > li {
  position: relative;
  /* 修改 */
  min-height: 100px;
}

.cbp_tmtimeline > li:first-child .cbp_tmtime span.large {
  color: #444;
  font-size: 17px !important;
  font-weight: 700;
}

.cbp_tmtimeline > li:first-child .cbp_tmicon {
  background: #fff;
  color: #666;
}

.cbp_tmtimeline > li:nth-child(odd) .cbp_tmtime span:last-child {
  color: #444;
  font-size: 13px;
}

.cbp_tmtimeline > li:nth-child(odd) .cbp_tmlabel {
  background: #f0f1f3;
}

.cbp_tmtimeline > li:nth-child(odd) .cbp_tmlabel:after {
  border-right-color: #f0f1f3;
}

.cbp_tmtimeline > li .empty span {
  color: #777;
}

.cbp_tmtimeline > li .cbp_tmtime {
  display: block;
  width: 23%;
  padding-right: 70px;
  position: absolute;
}

.cbp_tmtimeline > li .cbp_tmtime span {
  display: block;
  text-align: right;
}

.cbp_tmtimeline > li .cbp_tmtime span:first-child {
  font-size: 15px;
  color: #3d4c5a;
  font-weight: 700;
}

.cbp_tmtimeline > li .cbp_tmtime span:last-child {
  font-size: 14px;
  color: #444;
}

.cbp_tmtimeline > li .cbp_tmlabel {
  margin: 0 0 15px 25%;
  background: #f0f1f3;
  padding: 1.2em;
  position: relative;
  border-radius: 5px;
}

.cbp_tmtimeline > li .cbp_tmlabel:after {
  right: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-right-color: #f0f1f3;
  border-width: 10px;
  top: 10px;
}

.cbp_tmtimeline > li .cbp_tmlabel blockquote {
  font-size: 16px;
}

.cbp_tmtimeline > li .cbp_tmlabel .map-checkin {
  border: 5px solid rgba(235, 235, 235, 0.2);
  -moz-box-shadow: 0px 0px 0px 1px #ebebeb;
  -webkit-box-shadow: 0px 0px 0px 1px #ebebeb;
  box-shadow: 0px 0px 0px 1px #ebebeb;
  background: #fff !important;
}

.cbp_tmtimeline > li .cbp_tmlabel h2 {
  margin: 0px;
  padding: 0 0 10px 0;
  line-height: 26px;
  font-size: 16px;
  font-weight: normal;
}

.cbp_tmtimeline > li .cbp_tmlabel h2 a {
  font-size: 15px;
}

.cbp_tmtimeline > li .cbp_tmlabel h2 a:hover {
  text-decoration: none;
}

.cbp_tmtimeline > li .cbp_tmlabel h2 span {
  font-size: 15px;
}

.cbp_tmtimeline > li .cbp_tmlabel p {
  color: #444;
}

.cbp_tmtimeline > li .cbp_tmicon {
  width: 40px;
  height: 40px;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  font-size: 1.4em;
  line-height: 40px;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  color: #fff;
  /* background: #46a4da; */
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 5px #f5f5f6;
  text-align: center;
  left: 20%;
  top: 0;
  margin: 0 0 0 -25px;
}

@media screen and (max-width: 992px) and (min-width: 768px) {
  .cbp_tmtimeline > li .cbp_tmtime {
    padding-right: 60px;
  }
}

@media screen and (max-width: 65.375em) {
  .cbp_tmtimeline > li .cbp_tmtime span:last-child {
    font-size: 12px;
  }
}

@media screen and (max-width: 47.2em) {
  .cbp_tmtimeline:before {
    display: none;
  }
  .cbp_tmtimeline > li .cbp_tmtime {
    width: 100%;
    position: relative;
    padding: 0 0 20px 0;
  }
  .cbp_tmtimeline > li .cbp_tmtime span {
    text-align: left;
  }
  .cbp_tmtimeline > li .cbp_tmlabel {
    margin: 0 0 30px 0;
    padding: 1em;
    font-weight: 400;
    font-size: 95%;
  }
  .cbp_tmtimeline > li .cbp_tmlabel:after {
    right: auto;
    left: 20px;
    border-right-color: transparent;
    border-bottom-color: #f5f5f6;
    top: -20px;
  }
  .cbp_tmtimeline > li .cbp_tmicon {
    position: relative;
    float: right;
    left: auto;
    margin: -64px 5px 0 0px;
  }
  .cbp_tmtimeline > li:nth-child(odd) .cbp_tmlabel:after {
    border-right-color: transparent;
    border-bottom-color: #f5f5f6;
  }
}

.bg-green {
  background-color: #50d38a !important;
  color: #fff;
}

.bg-blush {
  background-color: #ff758e !important;
  color: #fff;
}

.bg-orange {
  background-color: #ffc323 !important;
  color: #fff;
}

.bg-info {
  background-color: #2ca8ff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/about/history.vue